import { Button } from '@/lib/components/ui/button';
import { Gift } from 'lucide-react';

export type SpecialOfferProps = {
  title: string;
  publicPrice: string;
  memberPrice: string;
  description: React.ReactNode;
  ctaText: string;
  ctaOnClick?: () => void;
  ctaHref?: string;
};

export const SpecialOffer = ({ title, publicPrice, memberPrice, description, ctaText, ctaOnClick, ctaHref }: SpecialOfferProps) => {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 p-6 shadow-lg mt-6">
      <div className="absolute right-4 top-4">
        <Gift className="h-8 w-8 text-orange-500" />
      </div>

      <div className="mb-6 inline-flex items-center rounded-full bg-primary px-3 py-1 text-xs font-semibold text-white">🛡️ {title}</div>

      <div className="mb-4 space-y-2">
        <span className="text-sm text-gray-700">
          Tarif public : <span className="font-semibold line-through">{publicPrice}</span>
        </span>
        <span className="text-sm text-gray-700">
          Tarif membre : <span className="font-semibold text-orange-600">{memberPrice}</span>
        </span>
      </div>

      <div className="mb-6 rounded-lg bg-primary-lighter/50 p-4">
        <p className="mb-2 text-sm font-semibold text-primary-darker">🟠 Économie immédiate :</p>
        <div className="text-sm text-gray-700">{description}</div>
      </div>

      <Button onClick={ctaOnClick} variant="cta" href={ctaHref}>
        {ctaText}
      </Button>
    </div>
  );
};
